export default "__VITE_ASSET__a314hnxK__"